<template>
    <div class="widget">
    <div class="line">
       <div class="title">Максимальные нормативные потери в сетях</div>
        <div class="date-select">
            <tep-lookup
                v-if="argsLookup"
                :value='NagrRasxDdatval'
                :meta='metaDdatval'
                :args="argsLookup"
                :data-source='lookupDdatval'
                @selected-value='onSelectDdatval'
            />
        </div>
        <div class="flex line">
            <div class="item">
                Qохл
                <ai-form-number-box-readonly
                    :meta='{fieldNameText: "qox"}'
                    :server-data='props.userData'
                ></ai-form-number-box-readonly>
                Ккал/час
            </div>
            <div class="item">
                Qут
                <ai-form-number-box-readonly
                    :meta='{fieldNameText: "qut"}'
                    :server-data='props.userData'
                ></ai-form-number-box-readonly>
                Ккал/час
            </div>
                <div class="item">
                    Qсум
                    <ai-form-number-box-readonly
                        :meta='{fieldNameText: "qsum"}'
                        :server-data='props.userData'
                    ></ai-form-number-box-readonly>
                    Ккал/час
                </div>
                <div class="item">
                    G
                    <ai-form-number-box-readonly
                        :meta='{fieldNameText: "g"}'
                        :server-data='props.userData'
                    ></ai-form-number-box-readonly>
                    т/ч
                </div>
            </div>
        </div>
        <div class="line">
            <ai-grid-ro
                ref='gridRef'
                :meta='gridMeta'
                :args='args'
                :to-remove-toolbar-items-names="removeRateToolbarItems"
                :show-grid-footer='false'
                :show-filter-panel='false'
                style="height: 250px"
            />
            <div class="block-sum">
                <table v-if="dataSumGrid">
                    <tr>
                        <td class="td-sum"></td>
                        <td class="td-sum">
                            <ai-form-number-box-readonly
                                :meta='{fieldNameText: "qoxl"}'
                                :server-data='dataSumGrid'
                            ></ai-form-number-box-readonly>
                        </td>
                        <td class="td-sum">
                            <ai-form-number-box-readonly
                                :meta='{fieldNameText: "qut"}'
                                :server-data='dataSumGrid'
                            ></ai-form-number-box-readonly>
                        </td>
                        <td class="td-sum">
                            <ai-form-number-box-readonly
                                :meta='{fieldNameText: "qsum"}'
                                :server-data='dataSumGrid'
                            ></ai-form-number-box-readonly>
                        </td>
                        <td class="td-sum">
                            <ai-form-number-box-readonly
                                :meta='{fieldNameText: "gut"}'
                                :server-data='dataSumGrid'
                            ></ai-form-number-box-readonly>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="line">
            <div class="title">Нормативные потери от границы раздела до узла учета</div>
            <table v-if="props.userData?.kod_vid === 50">
                <tr>
                    <td>Общие сети</td>
                    <td>
                        <ai-form-number-box-readonly
                            :meta='{fieldNameText: "qp"}'
                            :server-data='props.userData'
                        ></ai-form-number-box-readonly>
                    </td>
                    <td>Гкал/ч</td>
                    <td>
                        <ai-form-number-box-readonly
                            :meta='{fieldNameText: "gp"}'
                            :server-data='props.userData'
                        ></ai-form-number-box-readonly>
                    </td>
                    <td>т/ч</td>
                </tr>
                <tr>
                    <td>Сети отопления</td>
                    <td>
                        <ai-form-number-box-readonly
                            :meta='{fieldNameText: "qpso"}'
                            :server-data='props.userData'
                        ></ai-form-number-box-readonly>
                    </td>
                    <td>Гкал/ч</td>
                    <td>
                        <ai-form-number-box-readonly
                            :meta='{fieldNameText: "gpso"}'
                            :server-data='props.userData'
                        ></ai-form-number-box-readonly>
                    </td>
                    <td>т/ч</td>
                </tr>
                <tr>
                    <td>Сети ГВС</td>
                    <td>
                        <ai-form-number-box-readonly
                            :meta='{fieldNameText: "qpgw"}'
                            :server-data='props.userData'
                        ></ai-form-number-box-readonly>
                    </td>
                    <td>Гкал/ч</td>
                    <td>
                        <ai-form-number-box-readonly
                            :meta='{fieldNameText: "gpgw"}'
                            :server-data='props.userData'
                        ></ai-form-number-box-readonly>
                    </td>
                    <td>т/ч</td>
                </tr>
            </table>
            <table  v-if="props.userData?.kod_vid === 55">
                <tr>
                    <td>Паропровод</td>
                    <td>
                        <ai-form-number-box-readonly
                            :meta='{fieldNameText: "qp"}'
                            :server-data='props.userData'
                        ></ai-form-number-box-readonly>
                    </td>
                    <td>Гкал/ч</td>
                    <td>
                        <ai-form-number-box-readonly
                            :meta='{fieldNameText: "gp"}'
                            :server-data='props.userData'
                        ></ai-form-number-box-readonly>
                    </td>
                    <td>т/ч</td>
                </tr>
                <tr>
                    <td>Конденсатопровод</td>
                    <td>
                        <ai-form-number-box-readonly
                            :meta='{fieldNameText: "qk"}'
                            :server-data='props.userData'
                        ></ai-form-number-box-readonly>
                    </td>
                    <td>Гкал/ч</td>
                    <td>
                        <ai-form-number-box-readonly
                            :meta='{fieldNameText: "gk"}'
                            :server-data='props.userData'
                        ></ai-form-number-box-readonly>
                    </td>
                    <td>т/ч</td>
                </tr>
            </table>
        </div>
    </div>
</template>
<script>
export default {
    name: 'widget-teplopoteri',
}
// TODO:: Переделать сумму колонок, когда в компоненте ai-grid-ro появиться Summary
</script>
<script setup>
import { computed, onMounted, ref } from 'vue';
import tepService from '@/service/tep-service';
import AiGridRo from '@/components/ai-grid-ro/ai-grid-ro.vue';
import TepLookup from '@/views/tep/tep-nsi/components/tep-lookup.vue';
import AiFormNumberBoxReadonly from '@/components/card-component/ai-form-number-box-readonly.vue';

const props = defineProps({
    userData: {
        type: Object,
        default: () => {
            return {};
        },
    },
    action: {
        type: Function,
        default: null,
    },
});

const gridRef = ref(null);
const NagrRasxDdatval = ref(null);
const lookupDdatval = ref(null);
const argsLookup =ref(null);
const dataPoteriFields = ref(null);
const dataSumGrid = ref(null);

const args = computed(() => {
    const kod = props.userData?.kod;
    return {
        kod_sx: kod,
        kod_ddatval: NagrRasxDdatval.value
    }
})

onMounted(async() => {
    argsLookup.value = {
        kod_vid: props.userData.kod_vid,
        kod_sx:  props.userData.kod,
    }
    NagrRasxDdatval.value = await tepService.getNagrRasxDdatval(argsLookup.value);
    lookupDdatval.value = await  tepService.getLookupDdatval(argsLookup.value);
    if(NagrRasxDdatval.value === null && lookupDdatval.value.length) {
        NagrRasxDdatval.value = lookupDdatval.value?.[0].kod;
    }
    await getDataPoteriFields();
});

const onSelectDdatval = async (data) => {
    if(NagrRasxDdatval.value === data) return;
    NagrRasxDdatval.value = data;
    await getDataPoteriFields();
}

const getDataPoteriFields = async() => {
    const dataGrid = await gridRef.value?.setDataSource( false,{...argsLookup.value, kod_ddatval: NagrRasxDdatval.value});
    dataSumGrid.value = dataGrid.data.find(i => i.id_period === 0);
    await gridRef.value?.gridInstance.filter(
        ['id_period', '>', 0],
    );
    if(props.userData?.kod_vid === 50) {
        dataPoteriFields.value = await tepService.getPoteriWaterFields({...argsLookup.value, kod_ddatval: NagrRasxDdatval.value});
    } else if (props.userData?.kod_vid === 55) {
        dataPoteriFields.value = await tepService.getPoteriParFields({...argsLookup.value, kod_ddatval: NagrRasxDdatval.value});
    }
}

const metaDdatval = {
    keyExpr: 'kod',
    api: {
        select: 'tep-grid./tep/widgets/lookup-ddatval/get'
    },
    wordWrapEnabled: true,
    fieldNameText: "name",
    fieldNameId: "kod",
    hasntRoute: true,
    columns: [
        {
            caption: '',
            name: 'kod',
            dataField: 'kod',
            visible: false,
            width: 50,
            index: 1,
        },
        {
            caption: '',
            name: 'name',
            dataField: 'name',
            visible: true,
            index: 2,
            allowFiltering: false
        },
    ],
    viewId: "lookup-ddatval"
}

const removeRateToolbarItems = ['choice', 'searchPanel'];
const gridMeta = {
    keyExpr: 'id_period',
    'api': {
        'select': 'tep-grid./tep/widgets/poteri-grid/get',
    },
    columns: [
        {
            name: 'kod_sx',
            caption: 'kod_sx',
            dataField: 'kod_sx',
            visible: false,
            width: '250',
            index: 1,
            allowFiltering: false
        },
        {
            name: 'id_period',
            caption: 'id',
            dataField: 'id_period',
            visible: false,
            width: '250',
            index: 2,
            allowFiltering: false
        },
        {
            name: 'name',
            caption: 'Период',
            dataField: 'name',
            visible: true,
            width: '20%',
            index: 3,
            allowFiltering: false
        },
        {
            name: 'qoxl',
            caption: 'Потери с охл. Гкал',
            dataField: 'qoxl',
            visible: true,
            width: '20%',
            index: 4,
            allowFiltering: false,
            dataType: 'number'
        },
        {
            name: 'qut',
            caption: 'Потери с утеч. Гкал',
            dataField: 'qut',
            visible: true,
            width: '20%',
            index: 5,
            allowFiltering: false,
            dataType: 'number'
        },
        {
            name: 'qsum',
            caption: 'Сумма Гкал',
            dataField: 'qsum',
            visible: true,
            width: '20%',
            index: 6,
            allowFiltering: false,
            dataType: 'number'
        },
        {
            name: 'gut',
            caption: 'Потери воды m',
            dataField: 'gut',
            visible: true,
            width: '20%',
            index: 7,
            allowFiltering: false,
            dataType: 'number'
        },
    ],
    viewId: 'widget-teplopoteri-grid'
}

</script>
<style scoped>
.line {
    padding: 16px 0;
}
.line + .line {
    border-top: 2px solid rgba(191, 191, 191, .7);
}
.title {
    margin: 0 0 8px;
    font-weight: 500;
    font-size: 14px;
}
.widget :deep(.dx-field-label) {
    display: none;
}
:root:root .widget :deep(.dx-field-value) {
    width: 100%;
}
td, th {
    padding: 5px 10px;
}

.flex {
    display: flex;
    gap: 16px;
}

.item {
    display: flex;
    align-items: center;
    gap: 4px;
}

.block-sum {
    background: #F6FAFE;
    height: 32px;
    width: 100%;
}

.block-sum table {
    width: 100%;
}

.td-sum {
    padding: 0 1px;
    width: 20%;
}
</style>
